export const host = process.env.NODE_ENV =='production' ? '':'http://localhost:8082';


// WEBPACK FOOTER //
// ./src/config.js